import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FranchiseWithLang } from '../types/franchise';
import { LabelValueType } from '../components/AsyncFormSelect/AsyncFormSelect';
import { BetListTournamentType } from '../pages/bets/types/betListTypes';
import { RoutesType } from '../utils/routes';
import { ODD_FORMAT } from '../pages/managers/types/managerProfileTypes';

export interface UserInfoState {
  franchises: FranchiseWithLang[];
  permissions?: string[];
  allAvailableCountryCodes?: string[];
  companies?: LabelValueType[];
  sports?: LabelValueType[];
  tournaments?: BetListTournamentType[];
  managersFranchises?: LabelValueType[];
  username?: string;
  managerCurrencyCode?: string;
  managerCurrencyId?: string;
  managerOddsFormat?: ODD_FORMAT;
  autoCalculateOdds?: boolean;
  managerId?: number;
  configuration?: string;
  ManagerUuid?: string;
  IsGlobal?: boolean;
  Routes?: RoutesType[];
}

const initialState: UserInfoState = {
  franchises: [],
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setFranchises: (
      state: UserInfoState,
      action: PayloadAction<FranchiseWithLang[]>,
    ) => {
      state.franchises = action.payload;
    },
    setPermissions: (
      state: UserInfoState,
      action: PayloadAction<string[]>,
    ) => {
      state.permissions = action.payload;
    },
    setAvailableCountryCodes: (
      state: UserInfoState,
      action: PayloadAction<string[]>,
    ) => {
      state.allAvailableCountryCodes = action.payload;
    },
    setCompanies: (
      state: UserInfoState,
      action: PayloadAction<LabelValueType[]>,
    ) => {
      state.companies = action.payload;
    },
    setSports: (
      state: UserInfoState,
      action: PayloadAction<LabelValueType[]>,
    ) => {
      state.sports = action.payload;
    },
    setTournaments: (
      state: UserInfoState,
      action: PayloadAction<BetListTournamentType[]>,
    ) => {
      state.tournaments = action.payload;
    },
    setManagersFranchises: (
      state: UserInfoState,
      action: PayloadAction<LabelValueType[]>,
    ) => {
      state.managersFranchises = action.payload;
    },
    setUserInfo: (
      state: UserInfoState,
      action: PayloadAction<{
        username: string;
        currencyCode: string;
        currencyId: string;
        oddsFormat: ODD_FORMAT;
        autoCalculateOdds: boolean;
        configuration: string;
        managerId?: number;
        ManagerUuid: string;
        IsGlobal?: boolean;
        Routes: RoutesType[];
      }>,
    ) => {
      state.username = action.payload.username;
      state.managerCurrencyCode = action.payload.currencyCode;
      state.managerCurrencyId = action.payload.currencyId;
      state.managerOddsFormat = action.payload.oddsFormat;
      state.autoCalculateOdds = action.payload.autoCalculateOdds;
      state.configuration = action.payload.configuration;
      state.managerId = action.payload.managerId;
      state.ManagerUuid = action.payload.ManagerUuid;
      state.IsGlobal = action.payload.IsGlobal;
      state.Routes = action.payload.Routes;
    },
  },
});

export const {
  setFranchises,
  setPermissions,
  setAvailableCountryCodes,
  setCompanies,
  setSports,
  setTournaments,
  setManagersFranchises,
  setUserInfo,
} = userInfoSlice.actions;

export default userInfoSlice.reducer;
